import { Lookup, useLookup } from '@/providers'
import { Autocomplete, TextField } from '@mui/material'
import { UrlUpdateType } from 'use-query-params'

type Props = {
	value: string | null
	updateFilters: (changes: any, updateTypeOverride?: UrlUpdateType) => void
}

export default function SameManufacturer({ value, updateFilters }: Props) {
	const options = useLookup(Lookup.SameManufacturerSwitchFilters)

	const selectedValues = options.find((v) => v.id === value) || null

	const handleChange = (e, value) => {
		if (value) {
			updateFilters({ sameManufacturerSwitch: value.id })
		} else {
			updateFilters({ sameManufacturerSwitch: '' })
		}
	}

	return (
		<Autocomplete
			fullWidth
			size="small"
			options={options}
			value={selectedValues}
			onChange={handleChange}
			renderInput={(params) => <TextField {...params} label="Same Manufacturer" />}
			slotProps={{ paper: { style: { width: '24rem' } } }}
		/>
	)
}
